var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4",class:'bg-' + _vm.actualColor + '-100 border-l-4 border-' + _vm.actualColor + '-500 text-' + _vm.actualColor + '-700',attrs:{"role":"alert"}},[_c('p',{staticClass:"font-bold"},[_vm._t("title")],2),_vm._v(" "),_c('p',[_vm._t("description")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }